import { getLanguageCodeByLocale as i, LanguageCodeEnum as e } from "@systemeio/ui";
const c = (a, m, o, t) => {
  let r = i(o);
  switch (r) {
    case e.ARABIC:
      r = "ar-AE";
      break;
    case e.ALBANIA:
      r = e.ENGLISH;
      break;
  }
  return Intl.NumberFormat(r, {
    style: "currency",
    currency: m,
    currencyDisplay: "symbol",
    maximumFractionDigits: t ? 0 : void 0,
    minimumFractionDigits: t ? 0 : 2
    // we need 2 fractional digits for tests
  }).format(a);
};
export {
  c as getAmountWithCurrencySymbol
};
